export const TWITCH_PERIODS = [7, 30, 60, 90];

export function twitchDurationSeconds(duration = "") {
  const match = /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/.exec(duration);
  return match ? Number(match[1] || 0) * 3600 + Number(match[2] || 0) * 60 + Number(match[3] || 0) : 0;
}

export function broadcastStart(video) {
  return new Date(video.created_at || video.published_at).getTime();
}

export function summarizeBroadcasts(videos, days, now = Date.now()) {
  const cutoff = now - days * 86400000;
  if (!Array.isArray(videos)) return { broadcasts: null, hours: null, averageViewers: null };
  const broadcasts = videos.filter((video) => {
    const start = broadcastStart(video);
    const end = start + twitchDurationSeconds(video.duration) * 1000;
    return Number.isFinite(start) && start <= now && end > cutoff;
  });
  const seconds = broadcasts.reduce((sum, video) => {
    const start = broadcastStart(video);
    const end = start + twitchDurationSeconds(video.duration) * 1000;
    return sum + Math.max(0, Math.min(end, now) - Math.max(start, cutoff)) / 1000;
  }, 0);
  // Helix VOD views are not historical concurrent viewers. Missing history stays null.
  return { broadcasts, hours: seconds / 3600, averageViewers: null };
}

export function sortBroadcasts(videos, key = "date", direction = "desc") {
  return [...videos].sort((a, b) => {
    const value = (video) => key === "duration" ? twitchDurationSeconds(video.duration) : key === "title" ? video.title || "" : broadcastStart(video);
    const first = value(a), second = value(b);
    const comparison = typeof first === "string" ? first.localeCompare(second) : first - second;
    return direction === "asc" ? comparison : -comparison;
  });
}


export function mergeTrackedBroadcasts(videos, history) {
  const tracked = new Map((history?.broadcasts || []).map((row) => [row.id, row]));
  const combined = (videos || []).map((video) => {
    const row = tracked.get(video.stream_id);
    if (!row) return video;
    tracked.delete(video.stream_id);
    return { ...video, averageViewers: row.averageViewers, netFollowers: row.netFollowers, observedSeconds: row.observedSeconds };
  });
  for (const row of tracked.values()) combined.push({
    id: `tracked_${row.id}`, created_at: new Date(row.startedAt).toISOString(),
    title: row.title, duration: `${Math.round(row.observedSeconds)}s`,
    averageViewers: row.averageViewers, netFollowers: row.netFollowers,
    observedSeconds: row.observedSeconds, trackedOnly: true,
  });
  return combined;
}
